// extracted by mini-css-extract-plugin
export default {"form":"newticket_form__KhvJl","card":"newticket_card__nnVvs","bottom_container":"newticket_bottom_container__2JB9g"};